import type { ReactNode } from 'react';

/*
  As peças de layout do formulário, compartilhadas entre a página e as seções
  de array.

  Ficam num arquivo próprio porque os dois lados precisam delas, e duplicar o
  `<fieldset>` faria as duas metades do MESMO formulário divergirem no
  espaçamento — o tipo de diferença que se nota sem saber nomear.

  `<fieldset>` com `<legend>` de verdade, e não `<div>` com título: é o que
  agrupa os campos para o leitor de tela, e é o que permite ao teste alcançar
  um campo pela seção (`getByRole('group', { name: 'Sede e foro' })`) quando o
  mesmo rótulo aparece em duas.
*/

export function Secao({
  titulo,
  descricao,
  children,
}: {
  titulo: string;
  descricao?: string;
  children: ReactNode;
}) {
  return (
    <fieldset className="border-tinta-100 rounded-xl border p-4">
      <legend className="text-tinta-900 px-2 text-sm font-semibold">{titulo}</legend>
      {descricao && <p className="text-tinta-500 mb-3 text-xs">{descricao}</p>}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">{children}</div>
    </fieldset>
  );
}

export function LinhaCheia({ children }: { children: ReactNode }) {
  return <div className="sm:col-span-2">{children}</div>;
}
